export default function SecureAuthIcon() {
  return (
    <svg width='64' height='64' viewBox='0 0 64 64' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z'
        fill='#DBEAFE'
      />
      <path
        d='M42.6673 33.3333C42.6673 39.9999 38.0007 43.3333 32.454 45.2666C32.1635 45.365 31.848 45.3603 31.5607 45.2533C26.0007 43.3333 21.334 39.9999 21.334 33.3333V23.9999C21.334 23.6463 21.4745 23.3072 21.7245 23.0571C21.9746 22.8071 22.3137 22.6666 22.6673 22.6666C25.334 22.6666 28.6673 21.0666 30.9873 19.0399C31.2698 18.7986 31.6291 18.666 32.0007 18.666C32.3722 18.666 32.7315 18.7986 33.014 19.0399C35.3473 21.0799 38.6673 22.6666 41.334 22.6666C41.6876 22.6666 42.0267 22.8071 42.2768 23.0571C42.5268 23.3072 42.6673 23.6463 42.6673 23.9999V33.3333Z'
        stroke='#155DFC'
        stroke-width='2.66667'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}
